import React, { Component } from 'react';
import { Button } from "reactstrap"
import { fetchData } from "../common/networkRequests";
import { getRequiredField } from '../oro-module/commonFunctions';
import { handleConfirmSubmit } from "../oro-module/ajaxdata"


class EditCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmit: false,
      submitConfirm: false
    };
    // this.handleEdit = this.handleEdit.bind(this);

    // this.toggleDeletingDropdown = this.toggleDeletingDropdown.bind(this);
  }

  handleEdit = () => {
    let { submitConfirm } = this.state;
    this.setState({ submitConfirm: true })
  }

  handleConfirmCancel = () => {
    this.setState({ submitConfirm: false })
  }

  // handleConfirmEdit = async () => {
  //   let lgs = this.props.liftGlobalState;
  //   let {
  //     alerts,
  //     unsavedChanges,
  //     errorMessages,
  //     currentPage,
  //     pageData,
  //     LocalVars,
  //     fileFolder,
  //     fileFolderError,
  //     formElements, notifications, remoteip
  //   } = this.props.parentState;

  //   currentPage = currentPage.toLowerCase();
  //   const formDefinition = formElements[currentPage]["form"];
  //   let shouldProceed = true;
  //   let errors = [];
  //   for (var i = 0; i < formDefinition.length; i++) {
  //     let shouldRender = 1;
  //     let component = formDefinition[i];
  //     if (component.parents) {
  //       for (var j = 0; j < component.parents.length; j++) {
  //         let elem = component.parents[j];

  //         const parentVal = this.props.parentState.pageData[elem.name];

  //         if (
  //           elem.reverse &&
  //           ((elem.match === "exist" && parentVal) ||
  //             (elem.match === "value" && parentVal == elem.value))
  //         ) {
  //           shouldRender = 0;
  //           errors.push("1");
  //         } else if (
  //           !elem.reverse &&
  //           ((elem.match === "exist" && parentVal) ||
  //             (elem.match === "value" && parentVal == elem.value))
  //         ) {
  //           shouldRender = 1;
  //         } else {
  //           if (!elem.reverse) {
  //             shouldRender = 0;
  //           }
  //         }
  //       }
  //     }
  //   }

  //   getRequiredField({ shouldProceed: false, current: this })

  //   if (shouldProceed) {
  //     currentPage = currentPage.toLowerCase();
  //     const formDefinition = formElements[currentPage]["form"];

  //     let { token } = this.props.parentProps.parentState;
  //     let saveThis = {};
  //     saveThis['pageData'] = JSON.parse(JSON.stringify(this.props.parentState)).pageData;
  //     saveThis['currentPage'] = currentPage;
  //     // delete saveThis.formElements;
  //     // delete saveThis.navbarProperties;
  //     // delete saveThis.workFlowData;
  //     // delete saveThis.LocalVars;
  //     // delete saveThis.errorMessages;
  //     this.setState({ isSubmit: true });
  //     let CBSurl = `${remoteip}/sentry`;
  //     let url = CBSurl;
  //     let method = 'post';
  //     saveThis['dataType'] = 'formsubmit'
  //     saveThis['pageData']['submit_type'] = "edit";

  //     let { results, exceptions, error } = await fetchData({ url, postData: saveThis, method, headers: { Authorization: `JWT ${this.props.parentProps.parentState.token}` } });

  //     if (error) {
  //       notifications = { value: "Can not connect to the main server", alertType: "warning" };
  //       fileFolderError = { value: "Can not connect to the main server", alertType: "warning" }
  //       this.props.liftGlobalState({ name: 'notifications' }, notifications);
  //       this.props.liftGlobalState({ name: 'fileFolderError' }, fileFolderError);
  //       this.setState({ isSearch: false });
  //     } else {
  //       if (Object.keys(exceptions).length != 0) {
  //         alerts.unshift({ value: exceptions.message, alertType: "danger" })
  //         fileFolderError = { value: exceptions.message, alertType: "danger" }
  //         this.setState({ isSubmit: false });
  //         if (exceptions.message.includes("The user has been logged off.") == true) {
  //           setTimeout(() => document.getElementById("logout-button-hidden").click(), 10);
  //         }
  //       } else {
  //         fileFolder.isOpen = false;
  //         alerts.unshift({ value: "Data saved successfully", alertType: "success" })
  //         this.props.liftGlobalState({ name: 'notifications' }, {});
  //         this.props.liftGlobalState({ name: 'fileFolderError' }, {});
  //         alert("Updated successfully");
  //       }
  //       lgs({ name: "alerts" }, alerts);
  //       lgs({ name: "unsavedChanges" }, []);
  //       this.props.liftGlobalState({ name: 'notifications' }, {});
  //       let current = this;
  //       // setTimeout(function () {
  //       lgs({ name: "alerts" }, []);
  //       lgs({ name: 'pageData' }, {});
  //       // }, 2000);
  //     }

  //     this.setState({ isSubmit: false });

  //   } else {
  //     // this.setState({isSubmit:false});
  //     alerts.unshift({
  //       value: "There are errors on the form shown in RED color.",
  //       alertType: "danger"
  //     });

  //     lgs({ name: "alerts" }, alerts);

  //   }

  // }

  render() {
    let {
      alerts,
      unsavedChanges,
      errorMessages,
      currentPage,
      pageData,
      LocalVars,
      showButtons,
      fileFolder, formActions, formState
    } = this.props.parentState
    let otherPageData={submit_type:"edit"}
    return (
      <div>
        {fileFolder.isOpen && formState == "edit" && showButtons.edit && (
          <div className="row">
            {!this.state.isSubmit && !this.state.submitConfirm && <Button
              outline
              className="col-2 offset-5"
              onClick={this.handleEdit}
              color="success"
            >
              {" "}
              {formActions && formActions.edit && formActions.edit.text && (
                <span>{formActions.edit.text}</span>
              )}
              {(!formActions ||
                !formActions.edit ||
                !formActions.edit.text) && <span>Edit</span>}

            </Button>}
            {this.state.submitConfirm && <Button
              outline
              color="success" 
              className={`col-1 offset-5 black-submit-button`}
              
              onClick={()=>handleConfirmSubmit({current:this,otherPageData})}
              id="main-form-submit-button"
            >YES</Button>
            }
            {this.state.submitConfirm && <Button
              outline
              color="danger"
              style={{ marginLeft: "5px" }}
              className={`col-1  black-submit-button`}
              
              onClick={this.handleConfirmCancel}
              id="main-form-submit-button"
            >Cancel</Button>
            }
            {this.state.isSubmit &&
              <img width="10" className={`col-2 offset-5 `} style={{ textAlign: "center", }} src="/images/gif/spinner-min.gif" />
            }
          </div>
        )}
      </div>
    );
  }
}

export default EditCustom;